import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  BlockStack,
  Text,
  Divider,
  InlineStack,
} from "@shopify/polaris";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
  DragOverlay,
} from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
  arrayMove,
  useSortable,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import TaskCard from "./TaskCard";
import axios from "../../Assets/Lib/axios";
import TaskSlider from "../TaskSlider";
import TaskChatModal from "../TaskChat/TaskChatModal";

export default function ListView({ rows, statuses, onRefresh }) {
  const sensors = useSensors(useSensor(PointerSensor));
  const [chatTask, setChatTask] = useState(null);

  const [activeTaskId, setActiveTaskId] = useState(null);
  const [sliderOpen, setSliderOpen] = useState(false);
  const [tasks, setTasks] = useState(rows || []);
  useEffect(() => {
    setTasks(rows || {});
  }, [rows]);

  const handleDragStart = (event) => {
    const { active } = event;
    setActiveTaskId(active.id);
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;
    setActiveTaskId(null);
    if (!over) return;

    const fromCat = Object.keys(tasks).find((c) =>
      tasks[c].some((t) => t.id === active.id)
    );
    const toCat = Object.keys(tasks).find((c) =>
      tasks[c].some((t) => t.id === over.id)
    );

    // ⛔️ Stop if dragging across different categories
    if (fromCat !== toCat) return;

    // ✅ Reorder only within the same category
    const oldIndex = tasks[fromCat].findIndex((t) => t.id === active.id);
    const newIndex = tasks[toCat].findIndex((t) => t.id === over.id);
    if (oldIndex !== newIndex) {
      const reordered = arrayMove(tasks[fromCat], oldIndex, newIndex);
      setTasks((prev) => ({ ...prev, [fromCat]: reordered }));
      console.log("reordered=", reordered);

      const movedTask = reordered[newIndex];
      const prevTask = reordered[newIndex - 1] || null;
      const nextTask = reordered[newIndex + 1] || null;

      const payload = {
        task_id: movedTask.id,
        previous_id: prevTask ? prevTask.id : null,
        next_id: nextTask ? nextTask.id : null,
      };

      console.log("📤 Sending reorder payload:", payload);

      axios
        .post("/task-manager/sort", payload)
        .then((res) => {
          console.log("✅ Order updated successfully!", res.data);
          if (onRefresh) onRefresh();
        })
        .catch((err) => {
          console.error("❌ Failed to update order:", err);
        });
    }
  };

  //ALLOW ORDER FROM CATEGORY TO ANTOHER
  // const handleDragEnd = (event) => {
  //   const { active, over } = event;
  //   setActiveTask(null);
  //   if (!over) return;

  //   const fromCat = Object.keys(tasks).find((c) =>
  //     tasks[c].some((t) => t.id === active.id)
  //   );
  //   const toCat = Object.keys(tasks).find((c) =>
  //     tasks[c].some((t) => t.id === over.id)
  //   );
  //   if (!fromCat || !toCat) return;

  //   if (fromCat === toCat) {
  //     const oldIndex = tasks[fromCat].findIndex((t) => t.id === active.id);
  //     const newIndex = tasks[toCat].findIndex((t) => t.id === over.id);
  //     const reordered = arrayMove(tasks[fromCat], oldIndex, newIndex);
  //     setTasks((prev) => ({ ...prev, [fromCat]: reordered }));
  //   } else {
  //     const moved = tasks[fromCat].find((t) => t.id === active.id);
  //     setTasks((prev) => ({
  //       ...prev,
  //       [fromCat]: prev[fromCat].filter((t) => t.id !== active.id),
  //       [toCat]: [...prev[toCat], moved],
  //     }));
  //   }
  // };
  const handleLocalMove = (taskId, newStatusName) => {
    setTasks((prev) => {
      const updated = { ...prev };

      // Find the category the task belongs to
      const fromKey = Object.keys(prev).find((key) =>
        prev[key].some((t) => t.id === taskId)
      );
      if (!fromKey) return prev;

      // Update the status of that task
      updated[fromKey] = prev[fromKey].map((t) =>
        t.id === taskId ? { ...t, status: newStatusName } : t
      );

      // Return new object so React re-renders
      return { ...updated };
    });
  };

  return (
    <>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
      >
        <BlockStack gap="500">
          {Object.entries(tasks).map(([category, items]) => (
            // <Card key={category} padding="500">
            <BlockStack gap="100" key={category}>
              <div className="category-header">
                <Text tone="subdued">
                  <span style={{ color: "hsl(215 14% 54%)" }}>{category}</span>
                </Text>
                <span className="category-line" />
              </div>
              {/* <InlineStack align="center" blockAlign="center" gap="200">
              <Text variant="headingSm" fontWeight="medium" tone="subdued">
                {category}
              </Text>
              <Box flex="1">
                <Divider borderColor="border-inverse" />
              </Box>
            </InlineStack> */}
              <Card padding={0}>
                <SortableContext
                  items={items.map((t) => t.id)}
                  strategy={verticalListSortingStrategy}
                >
                  {/* <BlockStack gap="100"> */}
                  {items.map((task, index) => (
                    <React.Fragment key={task.id}>
                      <SortableTask
                        task={task}
                        statuses={statuses}
                        onRefresh={onRefresh}
                        onLocalMove={handleLocalMove}
                        onOpenSlider={(t) => {
                          setActiveTaskId(t.id);
                          setSliderOpen(true);
                        }}
                        onOpenChat={(t) => {
                          setChatTask(t); // ✅ THIS is onOpenChat
                        }}
                      />
                      {index < items.length - 1 && (
                        <Divider borderColor="border-inverse" />
                      )}{" "}
                      {/* ✅ divider between tasks */}
                    </React.Fragment>
                  ))}
                  {/* </BlockStack> */}
                </SortableContext>
              </Card>
            </BlockStack>
            // </Card>
          ))}
        </BlockStack>

        <DragOverlay>
          {activeTaskId && (
            <TaskCard
              task={Object.values(tasks)
                .flat()
                .find((t) => t.id === activeTaskId)}
            />
          )}
        </DragOverlay>

        {sliderOpen && activeTaskId && (
          <TaskSlider
            task={Object.values(tasks)
              .flat()
              .find((t) => t.id === activeTaskId)}
            closeSlider={() => setSliderOpen(false)}
            onRefresh={onRefresh}
          />
        )}
      </DndContext>
      {chatTask && (
        <TaskChatModal
          open={!!chatTask}
          task={chatTask}
          onClose={() => setChatTask(null)}
        />
      )}
    </>
  );
}

/* ------------- Sortable Wrapper for TaskCard ------------- */
function SortableTask({
  task,
  statuses,
  onRefresh,
  onLocalMove,
  onOpenSlider,
  onOpenChat,
}) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: task.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <TaskCard
        task={task}
        dragListeners={listeners}
        dragAttributes={attributes}
        statuses={statuses}
        onStatusChanged={onRefresh}
        onLocalMove={onLocalMove}
        onOpenSlider={onOpenSlider}
        onRefresh={onRefresh}
        onOpenChat={onOpenChat}
      />
    </div>
  );
}
